
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  Box,
  Grid,
} from "@mui/material";

import {


  TableContainer,
  TableHead,

  Typography,
} from "@mui/material";



import CurrencyCell from "../../../component/CurrencyCell";

export default function WGRGrandTotal({
  totals, summary
}) {
  return (
    <Paper
      elevation={4}
      sx={{
        mt: 3,
        overflow: "hidden",
        border: "2px solid",
        borderColor: "success.main",
      }}
    >
       <TableContainer>
      <Table size="small">
        <TableBody>
          <TableRow
            sx={{
              bgcolor: "success.light",
              "& td": {
                fontWeight: 700,
                fontSize: 15,
              },
            }}
          >
            <TableCell>
              GRAND TOTAL
            </TableCell>

            <TableCell align="right">
              <CurrencyCell
                value={totals.primeLabour}
              />
            </TableCell>

            <TableCell align="right">
              <CurrencyCell
                value={totals.primeStores}
              />
            </TableCell>

            <TableCell align="right">
              <CurrencyCell
                value={totals.onCostLabour}
              />
            </TableCell>

            <TableCell align="right">
              <CurrencyCell
                value={totals.onCostStores}
              />
            </TableCell>

            <TableCell align="right">
              <CurrencyCell
                value={totals.proforma}
              />
            </TableCell>

            <TableCell align="right">
              <CurrencyCell
                value={totals.profit}
              />
            </TableCell>

            <TableCell align="right">
              <CurrencyCell
                value={totals.supStores}
              />
            </TableCell>

            <TableCell align="right">
              <CurrencyCell
                value={totals.freight}
              />
            </TableCell>

            <TableCell align="right">
              <CurrencyCell
                value={totals.incentive}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

</TableContainer>



      <Grid
        container
        spacing={0}
        justifyContent="center"
        alignItems="flex-start"
        sx={{ mb: 20, px: 2 }}
      >
        <Grid size={{ xs: 12, md: 4 }}>

          <TableContainer
            component={Paper}
            variant="outlined"
            sx={{ mt: 3, maxWidth: 450 }}
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    colSpan={2}
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 16,
                    }}
                  >
                    STORE DATA SUMMARY
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>


                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{ bgcolor: "grey.100", py: 0.5 }}
                  />
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography fontWeight="bold">
                      DIRECT STORE
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Prime Cost Stores + DS8 + M-DR − MIN DS8
                    </Typography>
                  </TableCell>

                  <TableCell align="right">
                    <CurrencyCell value={summary.directStore} />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography fontWeight="bold">
                      RETURNED STORE (DRR)
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      DS8 − MIN DS8
                    </Typography>
                  </TableCell>

                  <TableCell align="right">
                    <CurrencyCell value={summary.returnedStore} />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Typography fontWeight="bold">
                      ON COST STORE
                    </Typography>
                    
                  </TableCell>

                  <TableCell align="right">
                    <CurrencyCell value={totals.onCostStores} />
                  </TableCell>
                </TableRow>


                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{ bgcolor: "grey.100", py: 0.5 }}
                  />
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>


        </Grid>

        <Grid size={{ xs: 12, md: 4 }} >

          <TableContainer
            component={Paper}
            variant="outlined"
            sx={{ mt: 3, maxWidth: 450 }}
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    colSpan={2}
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 16,
                    }}
                  >
                    STORE DATA CALCULATION SUMMARY
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow>
                  <TableCell><b>DS8</b></TableCell>
                  <TableCell align="right">
                    <CurrencyCell value={summary.ds8} />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell><b>MIN DS8</b></TableCell>
                  <TableCell align="right">
                    <CurrencyCell value={summary.minDs8} />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell><b>M-DR</b></TableCell>
                  <TableCell align="right">
                    <CurrencyCell value={summary.mDr} />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell><b>MFGD RET.</b></TableCell>
                  <TableCell align="right">
                    <CurrencyCell value={summary.mfgdRet} />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell><b>MINUS MFGD RET.</b></TableCell>
                  <TableCell align="right">
                    <CurrencyCell value={summary.minusMfgdRet} />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{ bgcolor: "grey.100", py: 0.5 }}
                  />
                </TableRow>


              </TableBody>
            </Table>
          </TableContainer>

        </Grid>



        <Grid size={{ xs: 12, md: 4 }} >

          <TableContainer
            component={Paper}
            variant="outlined"
            sx={{ mt: 3, maxWidth: 450 }}
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    colSpan={2}
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 16,
                    }}
                  >
                    LABOUR DATA SUMMARY
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>


 <TableRow>
                  <TableCell>
                    <Typography fontWeight="bold">
                     DIRECT LABOUR
                    </Typography>
                    
                  </TableCell>

                  <TableCell align="right">
                    <CurrencyCell value={totals.primeLabour} />
                  </TableCell>
                </TableRow>


                 <TableRow>
                  <TableCell>
                    <Typography fontWeight="bold">
                      ON COST LABOUR
                    </Typography>
                    
                  </TableCell>

                  <TableCell align="right">
                    <CurrencyCell value={totals.onCostLabour} />
                  </TableCell>
                </TableRow>



                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{ bgcolor: "grey.100", py: 0.5 }}
                  />
                </TableRow>


              </TableBody>
            </Table>
          </TableContainer>

        </Grid>



      </Grid>

    </Paper>
  );
}

